import type { Palette } from '@mui/material/styles';

import { colors } from './colors';

export const createDarkPalette = () => {
  return {
    mode: 'dark',
    primary: {
      main: `var(--sdk-primary, ${colors.blue[400]})`,
      contrastText: `var(--sdk-primary-contrast, ${colors.black})`,
      light: `var(--sdk-primary-light, ${colors.blue[700]})`,
      dark: `var(--sdk-primary-dark, ${colors.blue[300]})`,
    },
    secondary: {
      main: colors.blue[800],
      contrastText: colors.blue[100],
      light: colors.blue[700],
      dark: colors.blue[900],
    },
    tertiary: {
      main: colors.blue[800],
      contrastText: colors.blue[100],
    },
    text: {
      primary: colors.white,
      secondary: colors.grey[400],
    },
    background: {
      default: `var(--sdk-dark-bg, var(--body-background, ${colors.backgroundDark}))`,
      defaultChannel: undefined,
    },
    divider: colors.backgroundDark,
    common: {
      white: colors.grey[900],
      black: colors.white,
    },
    greys: {
      50: colors.backgroundDark,
      100: colors.grey[800],
      200: colors.grey[700],
      300: colors.grey[600],
      400: colors.grey[500],
      500: colors.grey[400],
      600: colors.grey[300],
      700: colors.grey[200],
      800: colors.grey[100],
      900: colors.white,
    },
    blues: {
      50: colors.blue[900],
      100: colors.blue[800],
      200: colors.blue[700],
      300: colors.blue[600],
      400: colors.blue[500],
      500: colors.blue[400],
      600: colors.blue[300],
      700: colors.blue[200],
      800: colors.blue[100],
      900: colors.blue[50],
    },
    greens: {
      50: colors.green[900],
      100: colors.green[800],
      200: colors.green[700],
      300: colors.green[600],
      400: colors.green[500],
      500: colors.green[400],
      600: colors.green[300],
      700: colors.green[200],
      800: colors.green[100],
      900: colors.green[50],
    },
    oranges: {
      50: colors.orange[900],
      100: colors.orange[800],
      200: colors.orange[700],
      300: colors.orange[600],
      400: colors.orange[500],
      500: colors.orange[400],
      600: colors.orange[300],
      700: colors.orange[200],
      800: colors.orange[100],
      900: colors.orange[50],
    },
    reds: {
      50: colors.red[900],
      100: colors.red[800],
      200: colors.red[700],
      300: colors.red[600],
      400: colors.red[500],
      500: colors.red[400],
      600: colors.red[300],
      700: colors.red[200],
      800: colors.red[100],
      900: colors.red[50],
    },
    purple: colors.purple,
    violet: colors.violet,
  } as Palette;
};
